import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, Home } from "lucide-react";

const STAGE = { move_in: "Move-in", move_out: "Move-out" };

// Compact, always-visible active-property identity strip for tool routes
// (capture/compare/dispute-letter) so users never lose track of which
// property they are documenting for. Self-fetches address + doc_type.
export function PropertyContextHeader({ propertyId, property: initial, backLabel = "Back to property" }) {
  const navigate = useNavigate();
  const [property, setProperty] = useState(initial || null);

  useEffect(() => {
    if (initial) { setProperty(initial); return; }
    let live = true;
    api.get(`/properties/${propertyId}`).then(({ data }) => { if (live) setProperty(data); }).catch(() => {});
    return () => { live = false; };
  }, [propertyId, initial]);

  const stage = property?.doc_type ? STAGE[property.doc_type] : null;

  return (
    <div className="mb-4" data-testid="property-context-header">
      <button
        data-testid="context-back-btn"
        onClick={() => navigate(`/property/${propertyId}`)}
        className="flex items-center gap-2 text-sm text-[#475569] hover:text-navy"
      >
        <ArrowLeft size={16} /> {backLabel}
      </button>
      {property?.address && (
        <div className="mt-2 flex items-center gap-2 min-w-0">
          <span className="grid place-items-center h-7 w-7 rounded-lg bg-brand/10 text-brand shrink-0"><Home size={15} /></span>
          <span data-testid="context-address" className="font-semibold text-navy truncate">{property.address}</span>
          {stage && <span className="shrink-0 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-[#EEF2F7] text-navy border border-[#DDE3EC]">{stage}</span>}
        </div>
      )}
    </div>
  );
}
